module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("e4NoR"))).then(() => parcelRequire('iDabs'));